<div class="report-form-container" *ngIf="!isLoadingFormOptions">
	<div class="title">
		{{ labels[reportType.label] ? labels[reportType.label] : reportType.label }} -
		{{ labels[reportSubType.label] ? labels[reportSubType.label] : reportSubType.label }}
	</div>
	<div class="dotted-input-container">
		<span class="label">{{ labels.lbl_rep_custom_nome }} *</span>
		<input type="text" (input)="nameReport = $event.target.value" [value]="nameReport" />
	</div>

	<cpi-dot-bounce-loading-effect class="ml-2" [color]="'var(--primary-color-1)'" *ngIf="isLoadingFormItems">
	</cpi-dot-bounce-loading-effect>

	<pcp-search-filter
		[availableFiltersGeneric]="reportFormOptions"
		[titleLabel]="'lbl_filtros_disponiveis'"
		[tipLabel]="''"
		(getFilterGeneric)="parseSelected($event)"
		(newTag)="reportType.name === 'request' ? getFormItems() : null"
		[mandatoryFilters]="['solutionArea']">
	</pcp-search-filter>

	<ng-container *ngIf="columnPresetListIAC.length > 0">
		<hr />
		<cpi-input-with-autocomplete
			[placeholder]="labels.lbl_procurar_predefinicao_colunas"
			[availableOptions]="columnPresetListIAC"
			[minInputLength]="0"
			[keepValue]="false"
			(onValueChange)="getPreset($event)"></cpi-input-with-autocomplete>
	</ng-container>

	<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'" *ngIf="isLoadingReportColumns"> </cpi-dot-bounce-loading-effect>

	<cpi-generic-form-gen
		[setGenericForm]="availableColumnsForm"
		*ngIf="availableColumnsForm.length > 0 && availableColumnsForm[0].items?.length > 0 && !isLoadingReportColumns">
	</cpi-generic-form-gen>

	<div class="button-container">
		<button class="button" [ngClass]="{ disabled: isUpdatingReport }" (click)="createReport()" *ngIf="formStage === 'register'">
			{{ labels.lbl_create_report }}
			<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdatingReport"></cpi-dot-bounce-loading-effect>
		</button>
		<button class="button" [ngClass]="{ disabled: isUpdatingReport }" (click)="updateReport()" *ngIf="formStage === 'edit'">
			{{ labels.lbl_geral_atualizar }}
			<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdatingReport"></cpi-dot-bounce-loading-effect>
		</button>
	</div>
</div>

<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'" *ngIf="isLoadingFormOptions"></cpi-dot-bounce-loading-effect>
